import { lazyWithRetry } from '../../routes/dashboard/_utils';

export const ChatVRTDock = lazyWithRetry(() =>
  import('./ChatVRTDock').then((module) => ({ default: module.ChatVRTDock }))
);
export { useChatVRTVisibility } from './useChatVRTVisibility';
export type { ChatVRTDockProps } from './ChatVRTDock';
export type {
  SupportAssistantActivity,
  SupportAssistantDockProps,
  SupportAssistantEvent,
  SupportAssistantLanguage,
  SupportAssistantSessionCost,
  SupportAssistantSessionContext,
  SupportAssistantSessionEvent,
  SupportAssistantTranscriptMessage,
  VRPilotFillFieldMode,
  VRPilotFillFieldRequest,
  VRPilotFillFieldResult,
  VRPilotHighlightResult,
  VRPilotHighlightRole,
  VRPilotHighlightTargetRequest,
} from '@vrplatform/voice-chat';
